// extracted by mini-css-extract-plugin
export default {"content":"CollectionYardsPage_content__VyEt8"};